import { Trans } from "@lingui/macro";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { WfButton } from "@WahooFitness/redesignr";

type RemovePasscodeDialogProps = {
  onRemove: () => void;
  onCancel: () => void;
};

const RemovePasscodeDrawer = ({ onRemove, onCancel }: RemovePasscodeDialogProps) => {
  return (
    <Box display="flex" flexDirection="column" width="100%" py={2} px={4}>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        gap={1}
        py={2}
      >
        <Typography variant="prose-lg-bold" textAlign="center">
          <Trans>Remove passcode from your ELEMNT</Trans>
        </Typography>
        <Typography variant="prose-sm" textAlign="center">
          <Trans>Anyone with your ELEMNT will be able to access and view your data.</Trans>
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        gap={1}
        py={2}
      >
        <WfButton
          hierarchy="tertiary"
          intent="destructive"
          size="large"
          fullWidth
          onClick={onRemove}
        >
          <Trans>Remove Passcode</Trans>
        </WfButton>
        <WfButton hierarchy="tertiary" intent="default" size="large" fullWidth onClick={onCancel}>
          <Trans>Cancel</Trans>
        </WfButton>
      </Box>
    </Box>
  );
};

export default RemovePasscodeDrawer;
